export default "__VITE_ASSET__CPk3aBgu__"